/**
 * Resolve mensagens amigáveis em pt-BR para o motivo de desconexão de um canal.
 *
 * Prioridade: code (mais confiável) → keyword no reason → fallback genérico.
 */

const MSG_TOKEN =
  'Token de acesso expirou ou foi revogado. Reconecte o canal.';
const MSG_LOGGED_OUT =
  'A sessão foi encerrada no aparelho. Escaneie o QR Code novamente.';
const MSG_GATEWAY =
  'A conexão com o WhatsApp caiu. Reconecte escaneando o QR Code.';
const MSG_HEALTH =
  'O canal não respondeu às verificações de saúde. Tente reconectar.';
const MSG_BANNED = 'O número foi bloqueado pelo provedor.';
const MSG_RATE_LIMIT = 'Limite de envio atingido. Aguarde e reconecte.';
const MSG_NETWORK = 'Falha de conexão com o provedor.';
const MSG_GENERIC = 'O canal foi desconectado. Tente reconectar.';

/** Auth-error codes that mean "token expired / revoked" (Meta Graph API). */
const AUTH_CODES = new Set(['190', '102', '10', '200', '273', '368', '459', '467']);

export function resolveDisconnectReason(
  info?: { reason?: string; code?: string },
): string {
  if (!info) return MSG_GENERIC;

  const { code, reason } = info;

  // ── code-first (most reliable) ──────────────────────────────────────────
  if (code) {
    if (code === 'health_check_failed') return MSG_HEALTH;
    if (code === 'gateway') return MSG_GATEWAY;
    if (AUTH_CODES.has(code)) return MSG_TOKEN;
  }

  // ── reason keyword (case-insensitive substring) ──────────────────────────
  if (reason) {
    const r = reason.toLowerCase();

    if (r.includes('token') || r.includes('401') || r.includes('auth') || r.includes('oauth') || r.includes('session')) {
      return MSG_TOKEN;
    }
    if (r.includes('logged out') || r.includes('loggedout')) {
      return MSG_LOGGED_OUT;
    }
    if (r.includes('banned') || r.includes('403')) {
      return MSG_BANNED;
    }
    if (r.includes('rate limit') || r.includes('429')) {
      return MSG_RATE_LIMIT;
    }
    if (r.includes('timeout') || r.includes('network') || r.includes('unreachable')) {
      return MSG_NETWORK;
    }

    // raw reason is meaningful enough to surface directly
    return reason;
  }

  return MSG_GENERIC;
}
